<template>
  <nav id="navigationBar" class="bg-white border-b pb-1 border-gray-100 dark:border-gray-600 dark:bg-gray-900">
    <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl pl-4 pr-3 md:px-8 py-4">
      <a v-if="headerStore.menuLayout" :href="headerStore.menuLayout[0].link" class="flex items-center">
        <img :src="headerStore.menuLayout[0].image" class="mr-3 h-8" alt="">
      </a>
      <div
        type="button"
        class="inline-flex items-center p-2 ml-1 text-sm rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
      >
      <button class="menu-mobile-btn" onclick="this.classList.toggle('opened');this.setAttribute('aria-expanded', this.classList.contains('opened'))" aria-label="Main Menu" @click="toggleItem()">
        <svg width="24" height="24" viewBox="0 0 100 100">
          <path class="line line1" d="M 20,29.000046 H 80.000231 C 80.000231,29.000046 94.498839,28.817352 94.532987,66.711331 94.543142,77.980673 90.966081,81.670246 85.259173,81.668997 79.552261,81.667751 75.000211,74.999942 75.000211,74.999942 L 25.000021,25.000058" />
          <path class="line line2" d="M 20,50 H 80" />
          <path class="line line3" d="M 20,70.999954 H 80.000231 C 80.000231,70.999954 94.498839,71.182648 94.532987,33.288669 94.543142,22.019327 90.966081,18.329754 85.259173,18.331003 79.552261,18.332249 75.000211,25.000058 75.000211,25.000058 L 25.000021,74.999942" />
        </svg>
      </button>
      </div>
      <div class="hidden justify-between items-center w-full md:flex md:w-auto md:order-1 list-none">
        <ul class="flex flex-col mt-4 text-md font-medium md:flex-row md:space-x-8 md:mt-0 no-disc">
          <li v-for="(item, index) in headerStore.menuItems" :key="index" class="cursor-pointer text-gray-700">
            <MenuButton :button="item" :index="index"/>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <div class="absolute right-0 w-full h-full">
    <div class="relative bg-white">
    <Transition name="slide-fade">
      <div v-show="show" class="block py-6 justify-between items-center w-full md:hidden md:w-auto md:order-1 list-none menu-shadow ">
        <ul class="flex flex-col py-6 border-b border-gray-100 md:flex-row md:space-x-8 md:mt-0 no-disc">
          <li v-for="(item, index) in headerStore.menuItems" :key="index" class="cursor-pointer">
            <MenuButton :button="item" :index="index"/>
          </li>
        </ul>
      </div>
    </Transition>
    </div>
    <div class="relative">
      <Transition name="slide-fade">
        <MegaMenu />
      </Transition>
    </div>
  </div>
</template>

<script setup>
import MegaMenu from './MegaMenu.vue'
import MenuButton from './MenuButton.vue'
import { useHeaderStore } from '@/stores'

import { ref } from 'vue'

const headerStore = useHeaderStore()

const show = ref(false)

function toggleItem() {
  if (show.value) {
    headerStore.showMenu = false    
  }
  show.value = !show.value
}

</script>